import { AdminService } from './../../_services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentService } from 'src/app/_services/student.service';
import { Subscription } from './../../_models/subscription';
import { Component, OnInit } from '@angular/core';
import { Student } from 'src/app/_models/student';
import Swal  from 'sweetalert2';
import { DateServiceService } from 'src/app/_services/date-service.service';
declare var window:any
@Component({
  selector: 'app-manage-student',
  templateUrl: './manage-student.component.html',
  styleUrls: ['./manage-student.component.css']
})
export class ManageStudentComponent implements OnInit {

  student = new Student()
  subscription= new Subscription()
  loading=true
  adminExtending=false
  current_server_enrolment_id =undefined
  adminUpdatingVersion=false
  enrolAdminExtendModal:any
  enrolment_extend_id:number
  constructor(
    private studentService:StudentService,
    private route: ActivatedRoute,
    private router:Router,
    private adminService:AdminService,
    private dateService:DateServiceService) {

   }
  ngOnInit(): void {
    this.loading=true
    this.route.params.subscribe(params => {
     if(params['server_user_id']){
       this.studentService.getByUserId(params['server_user_id']).subscribe(
        data=>{
          this.initStudent(data)
        }
       )
     }
    });
  }

  initStudent(data:Student){

    if(data!=null){
       this.student= data
       if(this.student['subscription_object']!=null){
        this.subscription=this.student['subscription_object']
        this.current_server_enrolment_id = this.subscription.server_enrolment_id
        this.subscription['start_date'] = this.dateService.formatDate(this.subscription['start_date'])
        this.subscription['end_date'] = this.dateService.formatDate(this.subscription['end_date'])
       }
       this.loading=false
    }
  }
  indexStudent(){
    this.router.navigate(["admin/student/index"])
  }
  deleteStudent(){
    this.adminService.deleteStudentByUserId(this.student.server_user_id).subscribe(
      val=>{
        let msg=""

        if(val=="success"){
          this.router.navigate(["admin/student/add",this.student.server_guardian_id])
          msg="Yes! Deleted"
        }else{
          msg="Nope!"
        }
        this.showAlert(msg)
      }
    )

  }

  adminUpdateVersion(server_enrolment_id:number){
    this.adminUpdatingVersion =true
    this.adminService.updateEnrolmentVersion(server_enrolment_id).subscribe(
      x=>{
        this.adminUpdatingVersion=false

      }
    )
  }
  showAlert(msg:String){
    Swal.fire({
    title: '<strong>Delete Student</strong>',
    icon: 'info',
    html: ""+msg,
    showCloseButton: true,
    allowOutsideClick: false,
    focusConfirm: true,
    confirmButtonText:'Close',
    confirmButtonAriaLabel: 'Close'
  })
}

adminExtendEnrolmentModalShow(enrolment_extend_id:number){
  this.enrolAdminExtendModal = new window.bootstrap.Modal(
    document.getElementById('enrolAdminExtendModal')
  );
  this.enrolment_extend_id=enrolment_extend_id
  this.enrolAdminExtendModal.show()
}

closeModel(){
  this.enrolAdminExtendModal.hide()
}
}
